import React from "react";
import s from "./ActionPopOverDetails.module.scss";
import { EyeOpenIcon } from "../../../../../../../../global components/Icons/EyeOpenIcon";
import { XCircleSolid } from "../../../../../../../../global components/Icons/XCircleSolid";
import { useNavigate } from "react-router-dom";
type PropType = {
  id: string;
  name: string;
};
function ActionPopOverDetails({ id, name }: PropType) {
  const navigate = useNavigate();
  const items: { label: string; icon: React.ReactNode; action: () => void }[] =
    [
      {
        label: "View details",
        action: () =>
          navigate(
            `/dashboard/api-management/requests/user/view-details/${id}`,
            { state: { fullName: name } }
          ),
        icon: <EyeOpenIcon className={s.icon} />,
      },
      
    ];
  return (
    <div className={s.wrapper}>
      {items.map((item, index) => (
        <div key={index} className={s.item} onClick={item.action}>
          {item.icon} <p className={s.label}>{item.label}</p>
        </div>
      ))}
    </div>
  );
}

export default ActionPopOverDetails;
